import { ImpersonationBanner } from "@repo/app-shell"
import { createRootRoute, Outlet } from "@tanstack/react-router"
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools"
import { Toaster } from "sonner"

export const Route = createRootRoute({
  component: RootComponent,
})

function RootComponent() {
  return (
    <>
      <ImpersonationBanner />
      <Outlet />
      <Toaster theme="system" />
      <TanStackRouterDevtools position="bottom-right" />
    </>
  )
}
